import { combineReducers } from 'redux';
import general from 'app/redux/features/pad-initialization/reducer/general.reducer';
import visitScheduleStep from 'app/redux/features/pad-initialization/reducer/visit-schedule-step/visitScheduleStep.reducer';
import calendar from 'app/redux/features/pad-initialization/reducer/visit-schedule-step/calendar.reducer';
import implantationScheduleStep from 'app/redux/features/pad-initialization/reducer/scheduleImplantationStep/scheduleImplantation.reducer';
import hospitalReleasePrevisionStep from 'app/redux/features/pad-initialization/reducer/hospitalReleasePrevisionStep/hospitalReleasePrevision.reducer';
import patientDischargeStep from 'app/redux/features/pad-initialization/reducer/dischargePatientStep/dischargePatient.reducer';
import prescriptionsScheduleStep from 'app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/schedulePrescriptions.reducer';
import visitsSuspensionStep from 'app/redux/features/pad-initialization/reducer/suspensionVisitsStep/suspensionVisits.reducer';
import feedback from 'app/redux/features/pad-initialization/reducer/feedback.reducer';
import schedulePrescriptionInfoModal from 'app/redux/features/pad-initialization/reducer/schedulePrescriptionsStep/modal/schedulePrescriptionInfo.reducer';

/**
 * Root reducer for pad-initialization (flattened state shape).
 * This is the pure combined reducer without backward compatibility.
 * The state structure is:
 * {
 *   general,
 *   visitScheduleStep,
 *   implantationScheduleStep,
 *   hospitalReleasePrevisionStep,
 *   patientDischargeStep,
 *   prescriptionsScheduleStep,
 *   visitsSuspensionStep,
 *   calendar,
 *   feedback
 * }
 */
export default combineReducers({
  general,
  visitScheduleStep,
  implantationScheduleStep,
  hospitalReleasePrevisionStep,
  patientDischargeStep,
  prescriptionsScheduleStep,
  visitsSuspensionStep,
  calendar,
  feedback,
  schedulePrescriptionInfoModal
});
